import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GEY_PRODUCTION_ACTIVITY';

export async function getProductionActivity(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getProductionActivity - Start');

        const getProductionActivity =
            await DashboardService.CodevService.getProductionActivity(userData, params);

        LoggerService.logInfo('Action - getProductionActivity - End - Success');

        return ResultModel.newSuccessResult(getProductionActivity);
    }
    catch (error) {
        LoggerService.logInfo('Action - getProductionActivity - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
